// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2473":"1112909a","9644":"1112909a"}[chunkId] + ".chunk.css";
};